"use client";
import e from "react";
import t from "./index.es59.js";
const r = t.div`
  :root {
    @keyframes spinner {
      0% {
        transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  width: 48px;
  height: 48px;
  animation: spinner 0.6s linear infinite;

  .full {
    stroke: #e1ebe4;
  }
  .part {
    stroke: #2f6341;
    stroke-dasharray: 32 126;
    stroke-dashoffset: 64;
  }
`, s = () => /* @__PURE__ */ e.createElement(r, null, /* @__PURE__ */ e.createElement("svg", { className: "spinner", viewBox: "0 0 50 50" }, /* @__PURE__ */ e.createElement(
  "circle",
  {
    className: "full",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "7.5"
  }
), /* @__PURE__ */ e.createElement(
  "circle",
  {
    className: "part",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "7.5"
  }
)));
export {
  s as default
};
//# sourceMappingURL=index.es20.js.map
